import ajaxService from './ajaxService';

export default {
  // 取得會籍資料
  getMemberType(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/member-type-query', body, headers);
  },
  // 取得會員資料
  getCustomerData(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/customerdataquery', body, headers);
  },
  // 取得所有會籍設定
  getMemberTypeSetting(param) {
    const queryString = new URLSearchParams(param).toString();

    return ajaxService.post(`/mbc/get/api/v1/member-type?${queryString}`);
  },
  // 取得會員關鍵指標
  getIndicator(headers) {
    return ajaxService.post('/mbc/get/api/v1/member/indicator', {}, headers);
  },
  // 取得會員客製 profile 設定
  getCustomProfileSetting(body) {
    return ajaxService.post('/mbc/post/api/v1/custom-profile-setting/custom-profile-id', body);
  },
  // 更新會員資料
  updateCustomerData(body, headers) {
    return ajaxService.post('/mbc/put/api/v2/customerdataupdate', body, headers);
  },
  // 取得會員帳號資訊
  getMemberAccount(param, headers) {
    const queryString = new URLSearchParams(param).toString();

    return ajaxService.post(`/mbc/get/api/v1/member-account?${queryString}`, {}, headers);
  },
  // 驗證登入帳號密碼
  postAccountInfo(body) {
    return ajaxService.post('/mbc/post/api/v1/account-info', body);
  },
  // 新增會員貼標
  addMemberTag(body) {
    return ajaxService.post('/mbc/post/api/v1/member-tag', body);
  },
  // 取得會員貼標
  getMemberTag(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/member-tag/memberid', body, headers);
  },
  // 取得會員個人通知
  getMemberNotice(param, headers) {
    const queryString = new URLSearchParams(param).toString();

    return ajaxService.post(`/mbc/get/api/v1/member/notice?${queryString}`, {}, headers);
  },
  // 新增會員個人通知
  async postMemberNotice(body) {
    try {
      const res = await ajaxService.post('/mbc/post/api/v1/member/notice', body);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
  // 取得會員個人通知未讀數
  getMemberNoticeUnreadCount(param, headers) {
    const queryString = new URLSearchParams(param).toString();

    return ajaxService.post(`/mbc/get/api/v1/member/notice/unreadCount?${queryString}`, {}, headers);
  },
  // 更新會員個人通知已讀時間
  patchMemberNoticeReadTime(body, headers) {
    return ajaxService.post('/mbc/patch/api/v1/member/notice/readTime', body, headers);
  },
  // 確認會員資料是否存在
  checkMemberExistence(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/member/checking/list', body, headers);
  },
  getAccountVerifier(param) {
    const queryString = new URLSearchParams(param).toString();
    return ajaxService.post(`/mbc/get/api/v1/account-verifier?${queryString}`);
  },
  postCustomerdataadd(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/customerdataadd', body, headers);
  },
};
